import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-kt-pagination',
  standalone: true,
  imports: [CommonModule, NgbPaginationModule, FormsModule],
  templateUrl: './kt-pagination.component.html',
  styleUrl: './kt-pagination.component.scss'
})
export class KtPaginationComponent {
  @Input() total: number = 100; // Total number of items
  @Input() page: number = 1; // Current page
  @Input() pageSize: number = 20; // Default page size
  @Input() paginationOptions: number[] = [10, 20, 50, 100, 500]; // Page size options
  @Output() pageChange: EventEmitter<{ page: number, pageSize: number; }> = new EventEmitter<{ page: number, pageSize: number; }>();

  get totalNoOfPages() {
    return Math.ceil((this.total / this.pageSize) || 0);
  }

  onPageChanged(page: number): void {
    this.page = page;
    this.pageChange.emit({ page: this.page, pageSize: this.pageSize });
  }
  
  onPageSizeChanged(pageSize: number): void {
    this.pageSize = pageSize;
    this.pageChange.emit({ page: this.page, pageSize: this.pageSize });
  }

}
